module.exports = __webpack_public_path__ + "static/img/huangjiachongwu.55c2e42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/huangjiachongwu.jpg
// module id = kJt8
// module chunks = 0